import jwt_decode from "jwt-decode";
export default {
  name: "auth",
  components: {
    jwt_decode,
  },
  getJwt() {
    return jwt_decode(localStorage.getItem('keyPassHub'));
  },
  getIsLogged() {

    if(!localStorage.keyPassHub){
      return false
    }

    let jwt = null
    try {
      jwt = this.getJwt();
    } catch (e) {
      return false;
    }

    if (jwt == '' || jwt == undefined || jwt == null) {
      return false;
    }

    let now = new Date().getTime() / 1000

    // El reloj del teléfono puede ir desfasado del servidor: con unos segundos de
    // atraso, iat > now sacaba al usuario recién autenticado. iat no se revisa aquí
    // (lo valida el API) y exp lleva 10 minutos de tolerancia.
    if (jwt.exp + 600 < now) {
      return false;
    }

    return true;
  }
}
